import React, { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import PrivateLayout from "../Layout/PrivateLayout";
import { getToken } from "../config";

interface RouteContainerProps {
  component: ReactNode;
  authRequired: boolean;
}

const RouteContainer: FC<RouteContainerProps> = ({ component, authRequired }) => {
  if (authRequired) {
    // if (!getToken()) {
    //   return <Navigate to="/login" />;
    // }
    return <PrivateLayout>{component}</PrivateLayout>;
  } else {
    return <>{component}</>;
  }
};

export default RouteContainer;